import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-1.5" }
const _hoisted_2 = { class: "block text-sm font-bold text-slate-700 capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? '*' : ''), 1),
    _createVNode(_component_AppSelect, {
      modelValue: _ctx.inputValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      options: _ctx.selectOptions,
      placeholder: `Pilih ${_ctx.label.toLowerCase()}...`,
      onChange: _ctx.updateValue
    }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
  ]))
}